// Bootstrap-Komponenten (Tooltips, Popovers) nach jedem Turbo-Render initialisieren
import "../init/bootstrap"

// Turbo
// @hotwired/turbo statt @hotwired/turbo-rails importieren,
// damit @anycable/turbo-stream das turbo-cable-stream-source Custom Element registrieren kann.
import * as Turbo from "@hotwired/turbo"
window.Turbo = Turbo

// Eigene Turbo-Stream-Actions (notify = Toast)
import "../init/stream_actions"

// AnyCable
import { start } from "@anycable/turbo-stream"
import cable from "../init/cable"
start(cable)

// Stimulus-Controller registrieren
import "../controllers"
